import ReactDOM from "react-dom";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import "./styling.css";

ReactDOM.render(<App />, document.getElementById("root"));

reportWebVitals();
